import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ncgr-card ncgr-card--rounded-to-normal" }
const _hoisted_2 = { class: "ncgr-container ncgr-pad-t-24 ncgr-pad-b-24" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "ncgr-typography-secondary-label ncgr-typography-small ncgr-mar-t-8" }, " ※ こちらのメールアドレス宛に予約確認メールが送信されます。 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, " 〒" + _toDisplayString(_ctx.address.zipCode), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.prefectureName) + _toDisplayString(_ctx.address.address1) + _toDisplayString(_ctx.address.address2) + _toDisplayString(_ctx.address.address3), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.address.lastName) + " " + _toDisplayString(_ctx.address.firstName) + " さま ", 1),
      _createElementVNode("p", null, " 電話番号：" + _toDisplayString(_ctx.address.phone), 1),
      _createElementVNode("p", null, " メールアドレス：" + _toDisplayString(_ctx.address.purchaserEmail), 1),
      _hoisted_3
    ])
  ]))
}